import { Outlet } from 'react-router-dom';

export default function DocumentVersions() {
    return (
        <Outlet />
    )
}
